import React from 'react';
import { Link } from 'react-router-dom'
import './card-style.css'
import EditNewQuestions1 from '../EditNewQuestions1';
import { cx } from '@emotion/css';
import * as styles from '../Questions/challanges.style.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faCircle, faCheckCircle, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import EditIcon from "../../assets/images/edit-icon.png";

function EditEventCard(props) {

    function showeditquestions(specificcategory, levels, limits, eventdisplay, category) {
        ////console.log("IN Edit event card")
        ////console.log(category)
        props.showeditquestions(specificcategory, levels, limits, eventdisplay, category);

    }

    function showdeleteevents1(id, name, category) {
        ////console.log(id)

        props.showdeleteevents(id, name, category);
    }

    function ReopenAssignment(id, name, category) {
        ////console.log(id)

        props.ReopenAssignment(id, name, category);


    }
    let { id, name, levels, specificcategory, limits, remainingattempts, totalquestions, eventdisplay, level, eventtype, category, maxnoofparticipants, time } = props.event;
    return (
        <div className='card text-center shadow'>
            <div className='overflow'>
                <div className={cx(styles.plusDelete)}>
                    <button onClick={() => showdeleteevents1(id, name, category)}>
                        <FontAwesomeIcon icon={faTimes} size="2x" />
                    </button>
                    <button onClick={() => ReopenAssignment(id, name, category)}>
                        <FontAwesomeIcon icon={faPlus} size="2x" />
                    </button>
                </div>


                {eventtype !== 'Assignments' ? <img src={props.imgsrc} alt='' className='card-img-top' width="150" height="220" /> : ""}

                {<Link to={{ pathname: "/editchallenge", state: { id: id, name: name, category: category, level: level, totalquestions: totalquestions, time: time, specificcategory: specificcategory, eventtype: eventtype, levels: levels, limits: limits, eventdisplay: eventdisplay, maxnoofparticipants: maxnoofparticipants } }}> <button className={cx(styles.editBtn)} ><img src={EditIcon} alt="" />
                </button> </Link>}

                {eventtype == 'Assignments' ? <img src={"../assets/" + category + ".png"} alt='' className='card-img-top' width="120" height="200" /> : ""}


                <div className='card-body text-dark'>
                    <h4 className='card-text'>{name}</h4>
                    {eventtype !== 'Assignments' ? <h4 className='card-text'>Level: {level}</h4> : ""}
                    {/* <h4 className='card-text'>Questions: {totalquestions} </h4> */}
                    {eventtype !== 'Assignments' ? <h6 className='card-text'>Remaining Attempts: {remainingattempts}</h6> : ""}


                    {maxnoofparticipants != 50000 ? <Link to={{ pathname: "/editevents", state: { specificcategory: specificcategory, levels: levels, limits: limits, eventdisplay: eventdisplay, category: category } }}> {<button className="editevenbutton">Edit Questions</button>}  </Link> : ""}






                    {<Link to={{ pathname: "/dashboard", state: { id: id, name: name, category: category, level: level } }}> <button className="editevenbutton" >DashBoard</button> </Link>}

                    {/* {maxnoofparticipants == 50000?<Link to={{ pathname: "/dashboard",  state: {id:id,name:name,category: category,level:level} }}> <button className = "editevenbutton" >DashBoard</button> </Link>:""}       
       
{<input type ="text" value = {maxnoofparticipants}/>} */}

                    {/* {maxnoofparticipants == 50000 ?<Link to={{ pathname: "/dashboard",  state: {id:id,name:name,category: category,level:level} }}><button className = "editevenbutton" >ReOpen</button>   </Link>:""}      */}




                </div>
            </div>
        </div>

    );
}






export default EditEventCard;
